module.exports = __webpack_public_path__ + "img/1_uk.f09933e0.svg";